"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Checkbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _excluded = ["classes", "label", "index", "value", "onChange"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// import clsx from 'clsx';
var styles = function styles(theme) {
  return {
    root: {},
    'shine-checkmark-container': {
      display: 'block',
      position: 'relative',
      paddingLeft: '48px',
      marginBottom: '12px',
      cursor: 'pointer',
      fontSize: '13pt',
      lineHeight: '18pt',
      fontWeight: '300',
      letterSpacing: '0px',
      WebkitUserSelect: 'none',
      MozUserSelect: 'none',
      MsUserSelect: 'none',
      userSelect: 'none',
      '& input': {
        position: 'absolute',
        opacity: 0,
        cursor: 'pointer'
      },
      '&:hover input ~ $shine-checkmark': {
        backgroundColor: '#e5e5e5'
      },
      '& input:checked ~ $shine-checkmark': {
        backgroundColor: '#fff',
        outline: '1px solid #939393'
      },
      '& input:checked ~ $shine-checkmark:after': {
        backgroundColor: '#fff',
        display: 'block'
      }
    },
    'shine-checkmark': {
      position: 'absolute',
      top: 0,
      left: 0,
      height: 25,
      width: 25,
      backgroundColor: theme.palette.white,
      outline: '1px solid #c8c8c8',
      '&:after': {
        content: '""',
        position: 'absolute',
        display: 'none',
        left: 9,
        top: 7,
        width: 5,
        height: 10,
        border: 'solid rgba(0,0,0,0.85)',
        borderWidth: '0px 3px 3px 0px',
        WebkitTransform: 'rotate(45deg)',
        MsTransform: 'rotate(45deg)',
        transform: 'rotate(45deg)'
      }
    },
    'approval-checkbox': {}
  };
};

var Checkbox = function Checkbox(props) {
  var classes = props.classes,
      label = props.label,
      index = props.index,
      value = props.value,
      onChange = props.onChange,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: classes.root
  }, rest), /*#__PURE__*/_react["default"].createElement("label", {
    className: classes['shine-checkmark-container']
  }, label, /*#__PURE__*/_react["default"].createElement("input", {
    className: classes['approval-checkbox'],
    type: "checkbox",
    "data-index": index,
    checked: value,
    onChange: onChange
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: classes['shine-checkmark']
  }, " ")));
};

exports.Checkbox = Checkbox;
Checkbox.defaultProps = {
  classes: {}
};
Checkbox.propTypes = {
  classes: _propTypes["default"].any,
  label: _propTypes["default"].any,
  index: _propTypes["default"].number,
  value: _propTypes["default"].bool,
  onChange: _propTypes["default"].func
};

var _default = (0, _reactJss["default"])(styles)(Checkbox);

exports["default"] = _default;